import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { MobileContainerAnimation, InputSearch, ContainerSearch, MobileCardItem } from "../../../../";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { SwitchStatus } from "../../../../core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    searchContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      paddingTop: "8px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    content: {
      padding: "80px 8px 12px 8px",
      width: "100%"
    },
    search: {
      borderRadius: "60px",
      margin: "0 8px"
    },
    defaultCard: {
      padding: "8px 4px"
    },
    my12: {
      margin: "12px 0"
    }
  };
});

var MobileCampusGroups = function MobileCampusGroups(props) {
  // console.log("MobileCampusGroups", props);
  var classes = useStyles();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleSearchChange = function handleSearchChange(event) {
    if (props.status === "success") {
      setValue(event.target.value);
    }
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement("div", {
    className: classes.searchContainer
  }, /*#__PURE__*/React.createElement(InputSearch, {
    value: value,
    classes: classes.search,
    onChange: handleSearchChange,
    placeholder: props.translation ? props.translation.placeholders ? props.translation.placeholders.search : "Search group" : "Search group"
  })), /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.content
      }, /*#__PURE__*/React.createElement(ContainerSearch, {
        search: value,
        searchParam: "name",
        options: props.data,
        template: function template(option) {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            template: "groupListStaff",
            data: option,
            classes: classes.my12
          });
        },
        notFound: function notFound() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            classes: classes.defaultCard
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.not_found : "We couldn't find what you are looking for"));
        },
        empty: function empty() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            classes: classes.defaultCard
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.empty : "There are no options"));
        }
      }));
    }
  }));
};

export { MobileCampusGroups };